/**
 * 클립보드 복사 — sandbox iframe·권한 거부 시 execCommand 폴백.
 * 호스트 iframe 에는 allow-clipboard-write 가 필요하다 (shared/postmessage.js).
 */

export async function copyTextToClipboard(text: string): Promise<boolean> {
  const value = text?.trim();
  if (!value) return false;

  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(value);
      return true;
    } catch {
      /* Clipboard API 거부( sandbox 등 ) → 폴백 */
    }
  }

  try {
    const textarea = document.createElement("textarea");
    textarea.value = value;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.left = "-9999px";
    textarea.style.top = "0";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(textarea);
    return ok;
  } catch {
    return false;
  }
}
